// import image from "../../assetsCon/assets/img/illustrations/auth-basic-login-mask-light.png";
import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
import { triggerNotification } from "../message/Msg";
import config from "../../config";
import AuthIllustration from "../../assetsCon/assets/img/illustrations/auth-login-illustration-light.png";
import maskImg from "../../assetsCon/assets/img/illustrations/auth-cover-login-mask-light.png";
import { Link } from "react-router-dom";
import ForgotPassTchr from "./ForgotPassTchr";
import RegistrationTeacher from "./RegistrationTeacher";

const LoginTeacher = () => {
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (token) {
      window.location.href = "/home";
    }
  }, []);

  //-------------------------------- state manager --------------------------------------
  const [forgotpass, setForgotpass] = useState(false);
  const [register, setRegister] = useState(false);
  const [formData, setFormData] = useState({
    username: "",
    password: "",
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  useEffect(() => console.log("regi: ", register), [register]);
  useEffect(() => console.log("forgot: ", forgotpass), [forgotpass]);
  // --------------------------------------- submit form / login --------------------------post
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check if the username and password fields are empty
    if (!formData.username.trim() || !formData.password.trim()) {
      // Show an error message if any of the fields is blank
      triggerNotification("error", "Input field cannot be empty!!");
      return; // Stop form submission
    }

    // Call the API with formData
    try {
      await fetch(`${config.host_url}teacher/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then(function (response) {
          return response.json();
        })
        .then(async function (data) {
          // console.log(data);
          if (data.status === 200) {
            localStorage.setItem("token", data.token);
            localStorage.setItem("usertype", data.usertype);
            localStorage.setItem("name", data.name);
            localStorage.setItem("profile", data.profile);
            window.location.href = "/home";
          } else {
            triggerNotification("error", "Please Enter a Valid Credential!!");
          }
        });
    } catch (error) {
      console.log(error);
      triggerNotification(
        "error",
        "Some Error Occur!! Please Login After Some Time"
      );
    }
  };
  return (
    <>
      <div className="authentication-wrapper authentication-cover">
        <div className="authentication-inner row m-0">
          {/* <!-- /Left Section --> */}
          <div
            className={`d-none d-lg-flex col-lg-${register ? 6 : 7} col-xl-${
              register ? 6 : 8
            } align-items-center justify-content-center p-5 pb-2`}
          >
            <img
              src={AuthIllustration}
              className="auth-cover-illustration w-100"
              alt="auth-illustration"
            />
            <img src={maskImg} className="authentication-image" alt="mask" />
          </div>
          {/* <!-- /Left Section --> */}

          {/* <!-- Login --> */}
          <div
            className={`bg-white d-flex col-12 col-lg-${
              register ? 6 : 5
            } col-xl-${
              register ? 6 : 4
            } align-items-center authentication-bg position-relative py-sm-5 px-4 py-4`}
          >
            {!forgotpass && !register ? (
              <div className="w-px-400 mx-auto pt-5 pt-lg-0">
                <div className="app-brand justify-content-center mt-3">
                  <img
                    className="app-brand-text demo text-heading fw-bold w-48 "
                    src="https://deepvecto.com/wp-content/uploads/2023/09/Deepvecto_Logo.png"
                  />
                </div>
                <div className="mt-4">
                  <h4 className="mb-2">Welcome to Deepvecto! 👋</h4>
                  <p className="mb-4">
                    Please login to your account and start the adventure
                  </p>

                  <form className="mb-3" method="POST" onSubmit={handleSubmit}>
                    <div className="form-floating form-floating-outline mb-3">
                      <input
                        type="text"
                        className="form-control"
                        id="username"
                        name="username"
                        value={formData.username}
                        onChange={handleChange}
                        placeholder="Enter your username"
                        autoFocus
                      />
                      <label htmlFor="username">Username</label>
                    </div>
                    <div className="mb-3">
                      <div className="form-password-toggle">
                        <div className="input-group input-group-merge">
                          <div className="form-floating form-floating-outline">
                            <input
                              type="password"
                              id="password"
                              className="form-control"
                              name="password"
                              value={formData.password}
                              onChange={handleChange}
                              placeholder="&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;&#xb7;"
                              aria-describedby="password"
                            />
                            <label htmlFor="password">Password</label>
                          </div>
                          <span className="input-group-text cursor-pointer">
                            <i className="mdi mdi-eye-off-outline"></i>
                          </span>
                        </div>
                      </div>
                    </div>

                    <div className="mb-3">
                      <button
                        className="btn btn-primary d-grid w-100"
                        type="submit"
                      >
                        Login
                      </button>
                    </div>
                  </form>
                  <span
                    className="text-[#7579FF]"
                    onClick={() => {
                      setForgotpass(true);
                      setRegister(false);
                    }}
                  >
                    Forgot Password?
                  </span>
                  <hr />
                  <p className="text-center ">
                    <span>New on our platform? </span>

                    <span
                      className="text-[#7579FF]"
                      onClick={() => {
                        setRegister(true);
                        setForgotpass(false);
                      }}
                    >
                      Create an account
                    </span>
                  </p>
                </div>
              </div>
            ) : forgotpass ? (
              <ForgotPassTchr forgot={setForgotpass} />
            ) : register ? (
              <RegistrationTeacher regi={setRegister} />
            ) : (
              ""
            )}
          </div>
          {/* <!-- /Login --> */}
        </div>
      </div>
    </>
  );
};

export default LoginTeacher;
